var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[_c('div',[_vm._v(_vm._s(_vm.h1)+_vm._s(_vm.h2)+":")]),_c('div',[_vm._v(_vm._s(_vm.m1)+_vm._s(_vm.m2)+":")]),_c('div',[_vm._v(_vm._s(_vm.s1)+_vm._s(_vm.s2))])])}
var staticRenderFns = []

export { render, staticRenderFns }